import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FacetsBlock from '../filings/FacetsBlock/FacetsBlock';
import Notification from '../../components/common/Notification';
import KnowledgeBaseLink from '../../components/advancedSearch/KnowledgeBaseLink';

import AdvancedSearchTab from '../../components/advancedSearch/AdvancedSearchTab';
import GeneralAllForm from '../../components/advancedSearch/initialForms/allCourts/GeneralForm';
import CasesAllForm from '../../components/advancedSearch/initialForms/allCourts/CasesForm';
import GeneralBankruptcyForm from '../../components/advancedSearch/initialForms/bankruptcy/GeneralForm';
import CasesBankruptcyForm from '../../components/advancedSearch/initialForms/bankruptcy/CasesForm';
import PetitionsBankruptcyForm from '../../components/advancedSearch/initialForms/bankruptcy/PetitionsForm';
import GeneralCivilForm from '../../components/advancedSearch/initialForms/civil/GeneralForm';
import CasesCivilForm from '../../components/advancedSearch/initialForms/civil/CasesForm';
import GeneralCriminalForm from '../../components/advancedSearch/initialForms/criminal/GeneralForm';
import CasesCriminalForm from '../../components/advancedSearch/initialForms/criminal/CasesForm';
import { parseQueryStringToObject } from '../../redux/actions/advancedSearchAction';

import '../filings/filings.less';

const courtRadios = [
  {
    type: 'all',
    label: 'All Courts',
    tabs: [
      {
        segment: 'general',
        label: 'General',
        component: GeneralAllForm,
      },
      {
        segment: 'cases',
        label: 'Cases',
        component: CasesAllForm,
      },
      {
        segment: 'case-activity',
        label: 'Case Activity',
        component: GeneralAllForm,
      },
    ],
  },
  {
    type: 'bankruptcy',
    label: 'Bankruptcy',
    tabs: [
      {
        segment: 'general',
        label: 'General',
        component: GeneralBankruptcyForm,
      },
      {
        segment: 'petitions',
        label: 'Petitions',
        component: PetitionsBankruptcyForm,
      },
      {
        segment: 'cases',
        label: 'Cases',
        component: CasesBankruptcyForm,
      },
    ],
  },
  {
    type: 'civil',
    label: 'Civil',
    tabs: [
      {
        segment: 'general',
        label: 'General',
        component: GeneralCivilForm,
      },
      {
        segment: 'cases',
        label: 'Cases',
        component: CasesCivilForm,
      },
    ],
  },
  {
    type: 'criminal',
    label: 'Criminal',
    tabs: [
      {
        segment: 'general',
        label: 'General',
        component: GeneralCriminalForm,
      },
      {
        segment: 'cases',
        label: 'Cases',
        component: CasesCriminalForm,
      },
    ],
  },
  {
    type: 'appellate',
    label: 'Appellate',
    tabs: [
      {
        segment: 'general',
        label: 'General',
        component: GeneralAllForm,
      },
      {
        segment: 'cases',
        label: 'Cases',
        component: CasesAllForm,
      },
    ],
  },
];

const AdvancedSearch = props => {
  const { location } = props;
  const queryObject = parseQueryStringToObject(location.search);
  const { courtType, tab } = props.match.params;
  const selectedCourt = courtRadios.find(court => court.type === courtType) || courtRadios[0];
  const SelectedForm = (selectedCourt.tabs.find(t => t.segment === tab) || selectedCourt.tabs[0]).component;

  const radiosSelector = courtRadios.map(({ type, label }) => (
    <div className={`form-item${courtType === type ? ' selected' : ''}`} key={type}>
      <label className="option">
        <Link
          to={{
            pathname: `/advanced-search/${type}`,
            search: location.search,
          }}
        >
          <input type="radio" name={type} checked={courtType === type} onChange={() => null} className="form-radio" />
        </Link>{' '}
        {label}
      </label>
    </div>
  ));

  const tabsSelector = selectedCourt.tabs.map(({ segment, label }) => {
    const selectedCls = tab === segment ? 'ui-state-default ui-tabs-selected ui-state-active' : 'ui-state-default';

    return (
      <li className={selectedCls} key={segment}>
        <Link
          to={{
            pathname: `/advanced-search/${courtType}/${segment}`,
            search: location.search,
          }}
        >
          <span>{label}</span>
        </Link>
      </li>
    );
  });

  return (
    <div className="filings filings-page">
      <Notification />
      <FacetsBlock type="advanced-search" />

      <div className="filings-forms">
        <KnowledgeBaseLink />
        <h1 className="title">Advanced Search</h1>

        <div className="court-type-wrapper">
          <div className="form-radios">{radiosSelector}</div>
        </div>
        <div className="clear" />

        <ul className="ui-tabs-nav ui-helper-reset ui-helper-clearfix filings-forms-tabs">{tabsSelector}</ul>
        <div className="inside-block ui-tabs-panel ui-widget ui-widget-content ui-corner-bottom">
          <AdvancedSearchTab
            history={props.history}
            courtType={courtType}
            tab={tab}
            queryParams={queryObject}
            InitialForm={SelectedForm}
          />
        </div>
      </div>
    </div>
  );
};

AdvancedSearch.propTypes = {
  match: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired,
  location: PropTypes.any.isRequired,
};

export default AdvancedSearch;



// WEBPACK FOOTER //
// ./src/pages/advancedSearch/AdvancedSearch.jsx